module.exports = __webpack_public_path__ + "static/media/pause icon.0dd5e586.svg";